export const START_BOOST = 'boost/START_BOOST';
export const START_BOOST_SUCCESS = 'boost/START_BOOST_SUCCESS';
export const START_BOOST_FAILURE = 'boost/START_BOOST_FAILURE';

export const SEND_BOOST_TUTORIAL_VIEWED = 'boost/SEND_BOOST_TUTORIAL_VIEWED';
export const SEND_BOOST_TUTORIAL_VIEWED_FAILURE = 'boost/SEND_BOOST_TUTORIAL_VIEWED_FAILURE';
export const START_BOOST_TIMER = 'boost/START_BOOST_TIMER';
export const BOOST_END = 'boost/BOOST_END';
export const SET_BOOST_SOURCE_VERSION = 'boost/SET_BOOST_SOURCE_VERSION';

export const START_POLL_PRIMETIME_BOOST = 'boost/START_POLL_PRIMETIME_BOOST';
export const STOP_POLL_PRIMETIME_BOOST = 'boost/STOP_POLL_PRIMETIME_BOOST';
